import { AxiosResponse } from 'axios';
import api from './Api'

const sendSlackUsingWebhook = (message: string): Promise<AxiosResponse<ITeacherDetail, any>> => {
    return api.post(`/slack/send`, { message });
}

export { sendSlackUsingWebhook }